module.exports = __webpack_public_path__ + "img/logo-mini.b1f201cf.svg";